var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.975 1.346c.382.187.59.608.507 1.025L11.456 7.5h5.107a.937.937 0 0 1 .708 1.552l-8.125 9.375a.938.938 0 0 1-1.628-.798L8.544 12.5H3.438a.938.938 0 0 1-.709-1.552l8.125-9.374a.94.94 0 0 1 1.121-.228",
  clipRule: "evenodd"
})));
SvgBolt.displayName = "SvgBolt";
export { SvgBolt as ReactComponent };
export default SvgBolt;